import React from 'react';
import Main from './Main';
import AppEnv from './Env/AppEnv';

const App: React.FC = () => (
	<>
		<AppEnv />
		<Main />
	</>
);

export default App;
